import React from 'react';
import { Section } from './ui/Section';
import { motion } from 'framer-motion';
export function AudioSampleSection() {
  return <Section className="bg-transparent py-12 md:py-16" data-id="element-40">
      <motion.div initial={{
      opacity: 0,
      y: 30
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.7,
      ease: [0.22, 1, 0.36, 1]
    }} className="max-w-3xl mx-auto" data-id="element-41">
        <div className="p-6 md:p-8 bg-black/50 backdrop-blur-md border border-[#D4AF37]/20 rounded-2xl shadow-2xl" data-id="element-42">
          <p className="text-lg text-gray-100 leading-relaxed text-center" data-id="element-43">
            <span className="text-[#D4AF37] font-bold text-xl block mb-2 drop-shadow-[0_1px_3px_rgba(0,0,0,0.8)]" data-id="element-44">
              ¿Te ha pasado?
            </span>
            Empiezas con entusiasmo, pero no logras mantener el ritmo. No es tu
            culpa. No te falta motivación, te falta un sistema. Con el Sistema
            Anticaos™, vas a aprender cómo construir disciplina, enfoque y
            estabilidad, incluso en tus peores días.
          </p>
        </div>
      </motion.div>
    </Section>;
}